export default __webpack_public_path__ + "static/media/03.afe4308e.jpg";